// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"c6c0d739","455":"c207eb61","550":"507fe3fa","977":"2499bc86"}[chunkId] + ".chunk.js";
};